import { createSlice } from "@reduxjs/toolkit";

export const modelSlice = createSlice({
    name: 'models',
    initialState: {
        value: []
    },
    reducers: {
        add: (state, action) => {
            state.value.push( action.payload );
        },
        addMany: (state, action) => {
            state.value = [ ...state.value, ...action.payload ];
        },
        setModels: (state, action) => {
            state.value = action.payload;
        }
    }
});

export const { add, addMany , setModels} = modelSlice.actions;

export default modelSlice.reducer;
